import * as Yup from 'yup';

import { i18n } from 'utils';

export const FIELDS_VALIDATION = Yup.array()
    .of(
        Yup.object().shape({
            score: Yup.string()
                .matches(/^\d+(\.\d+)?(,\d+)?$/, i18n.t('mustBeANumber'))
                .optional(),
            scoringSystemId: Yup.string(),
        })
    )
    .optional();
